export default {
    name: 'EditPanelMixin',
    inject: {
        userForm: {
            from: 'userForm',
            default: null
        }
    },
    data() {
        return {
            IsSysAdmin: false,
            CurUserForm: null
        };
    },
    computed: {
        IsInEditTemplate: function() {
            return (
                this.CurUserForm.CurViewState !==
                this.CurUserForm.Cfg.ViewState.RecList
            );
        },
        Locale: function() {
            return antd?.locales?.zh_CN;
        },
        EditPanelTitle: function() {
            let _vewStateDesc = { Add: '增加', Update: '修改', View: '查看' };

            return (
                _vewStateDesc[this.CurUserForm.CurViewState] +
                this.CurUserForm.UserFormDesc.replace('管理', '')
            );
        },
        CurRecData: {
            get: function() {
                return this.CurUserForm.CurRecData;
            },
            set: function(val) {
                this.CurUserForm.CurRecData = val;
            }
        },
        ColInfoEdit: function() {
            return this.CurUserForm.ColInfoEdit;
        }
    },
    watch: {},
    created: function() {
        this.GetCurUserForm();

        CmnMis.Func.IsSysAdmin().then(data => {
            this.IsSysAdmin = data;
        });

        this.IsSaveing = false;
    },
    methods: {
        //获取当前表单
        GetCurUserForm: function() {
            this.CurUserForm = this.userForm || CmnMis.CurUserForm;
        },
        //保存按钮点击的时候
        OnSaveClick: function() {
            this.CurUserForm.Save();

            // if (this.IsSaveing) {
            //     Cmn.Modal.Alert(
            //         '当前表单没有处于修改记录或添加记录状态，不需要保存。'
            //     );
            //     return;
            // }

            // var _verify = this.CurUserForm.VerifyControlInput();

            // if (_verify !== true) {
            //     _verify !== false && Cmn.Modal.Error(_verify);
            //     return;
            // }

            // this.IsSaveing = true;

            // //保存之前
            // try {
            //     if (this.CurUserForm.BeforeSave.Trigger() === false) {
            //         this.IsSaveing = false;
            //         return;
            //     }
            // } catch (err) {
            //     Cmn.Modal.Error(err + '');
            //     this.IsSaveing = false;

            //     throw err;
            // }

            // //修改保存
            // if (
            //     this.CurUserForm.CurViewState ===
            //     this.CurUserForm.Cfg.ViewState.Update
            // ) {
            //     try {
            //         if (
            //             this.CurUserForm.BeforeUpdateSave.Trigger([
            //                 this.CurUserForm.CurRecID
            //             ]) === false
            //         ) {
            //             this.IsSaveing = false;
            //             return;
            //         }
            //     } catch (err) {
            //         Cmn.Modal.Error(err + '');
            //         this.IsSaveing = false;

            //         throw err;
            //     }

            //     this.CurUserForm.UpdateRec()
            //         .then((data) => {

            //             if (data.IsSuccess == '1') {

            //                 Cmn.Modal.Success(
            //                     this.CurUserForm.Cfg.PromptCopy.UpdateSuccess
            //                 );

            //                 this.CurUserForm.ShowRecListPanel(
            //                     this.CurUserForm.DataPaging.CurPage
            //                 );

            //             } else {

            //                 Cmn.Modal.Error(
            //                     CmnMis.Func.FormatString(
            //                         this.CurUserForm.Cfg.PromptCopy.UpdateFail,
            //                         data.ErrMsg
            //                     )
            //                 );
            //             }
            //         })
            //         .finally(() => {
            //             this.IsSaveing = false;
            //         });
            // }
            // //添加保存
            // else if (
            //     this.CurUserForm.CurViewState ===
            //     this.CurUserForm.Cfg.ViewState.Add
            // ) {
            //     try {
            //         if (
            //             this.CurUserForm.BeforeAddSave.Trigger([
            //                 this.CurUserForm.CurRecID
            //             ]) === false
            //         ) {
            //             this.IsSaveing = false;
            //             return;
            //         }
            //     } catch (err) {
            //         Cmn.Modal.Error(err + '');
            //         this.IsSaveing = false;

            //         throw err;
            //     }

            //     this.CurUserForm.AddRec()
            //         .then(data => {
            //             if (data.IsSuccess == '1') {
            //                 //是否使用连续增加
            //                 if (this.CurUserForm.IsUseContinueAdd) {
            //                     Cmn.Modal.Confirm(
            //                         this.CurUserForm.Cfg.PromptCopy
            //                             .IsContinueAdd,
            //                         () => {
            //                             this.CurUserForm.ShowAddRecPanel();
            //                         },
            //                         () => {
            //                             this.CurUserForm.ShowRecListPanel();
            //                         }
            //                     );
            //                 } else {
            //                     Cmn.Modal.Success(
            //                         this.CurUserForm.Cfg.PromptCopy.AddSuccess
            //                     );
            //                     this.CurUserForm.ShowRecListPanel();
            //                 }
            //             } else {
            //                 Cmn.Modal.Error(
            //                     CmnMis.Func.FormatString(
            //                         this.CurUserForm.Cfg.PromptCopy.AddFail,
            //                         data.ErrMsg
            //                     )
            //                 );
            //             }
            //         })
            //         .finally(() => {
            //             this.IsSaveing = false;
            //         });
            // } else {
            //     Cmn.Modal.Alert(
            //         '当前表单没有处于修改记录或添加记录状态，不需要保存。'
            //     );

            //     this.IsSaveing = false;
            // }
        },
        //取消按钮点击的时候
        OnCancelClick: function() {
            this.CurUserForm.Cancel();
            // if (this.CurUserForm.OnCancel.Trigger() === false) {
            //     return;
            // }

            // this.CurUserForm.ShowRecListPanel(
            //     this.CurUserForm.DataPaging.CurPage
            // );
        }
    }
};
